import { useEffect, useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api } from "@/lib/api";
import { useSettings } from "@/lib/hooks";
import { CounsellorsCard } from "@/components/CounsellorsCard";

const FIELDS = [
  ["school_name", "School Name"],
  ["school_address", "School Address"],
  ["school_contact", "Contact (phone / email)"],
  ["academic_year", "Academic Year"],
];

export default function Settings() {
  const qc = useQueryClient();
  const { data } = useSettings();
  const [f, setF] = useState(null);
  useEffect(() => { if (data) setF(data); }, [data]);

  const save = async () => {
    if (!f.school_name.trim()) return toast.error("School name is required");
    const r = await api.put("/settings", f);
    qc.setQueryData(["settings"], r.data);
    toast.success("Settings saved");
  };

  if (!f) return null;
  return (
    <div className="max-w-2xl">
      <div className="fade-up mb-4">
        <div className="text-xs uppercase tracking-[0.2em] text-plum-700">Receipt header</div>
        <h1 className="font-display mt-0.5 text-3xl font-bold leading-tight tracking-tight text-plum-950 sm:text-4xl">Settings</h1>
      </div>
      <div className="fade-up d1 space-y-4 rounded-lg border border-plum-900/10 bg-white p-6">
        {FIELDS.map(([k, l]) => (
          <div key={k} className="space-y-1.5">
            <Label htmlFor={k} className="text-xs text-slate-600">{l}</Label>
            <Input id={k} value={f[k] || ""} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`settings-${k}`} />
          </div>
        ))}
        <Button onClick={save} className="bg-plum-700 hover:bg-plum-800" data-testid="settings-save-btn"><Save className="mr-2 h-4 w-4" />Save Settings</Button>
      </div>
      <CounsellorsCard />
    </div>
  );
}
